<template>
    <div class="user-systems">
        <page-header :text="$t('users.userChangelog')" />

        <page-subnavigation :items="userDetailLinks" />

        <div class="table-wrapper">
            <table class="table table-filter table--striped table--filterable" v-if="items">
                <thead>
                    <tr>
                        <th v-for="field in fields" :key="field.value" class="table-filter__trigger" :width="field.width">
                            <div>{{ $t(field.title) }}</div>
                            <div
                                v-if="field.sortable"
                                class="table-filter__sorting"
                                @click="sortClickHandler(field.value)"
                                :class="{
                                    asc: activeSorting[field.value] === 'asc',
                                    desc: activeSorting[field.value] === 'desc',
                                }"
                            >
                                <i class="icon icon--common-caret"></i>
                            </div>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(log, index) in filteredLogs" :key="log + '_' + index" class="table__row table__row--clickable">
                        <td>
                            {{ formatDate(log.created_at, 'Y-m-d H:i:s') }}
                        </td>
                        <td>
                            <div v-for="(c, key) in log.changes" :key="index + '_' + key">
                                <b v-if="key === 'disabled_at'">{{ $t('users.activestate') }}</b>
                                <b v-else>{{ $t('fields.' + key) }}</b>
                            </div>
                        </td>
                        <td>
                            <div v-for="(c, key) in log.changes" :key="index + '_' + key">
                                <span v-if="key === 'disabled_at' && c[0] === null">{{ $t('systems.logs.active') }}</span>
                                <span v-else-if="key === 'disabled_at' && c[0] !== null">{{ $t('systems.logs.inactive') }}</span>
                                <span v-else>
                                    <template v-if="c[0] === ''"
                                        >-</template
                                    >
                                    <template v-else>{{ c[0] }}</template>
                                </span>
                            </div>
                        </td>
                        <td>
                            <div v-for="(c, key) in log.changes" :key="index + '_' + key">
                                <span v-if="key === 'disabled_at' && c[1] === null">{{ $t('systems.logs.active') }}</span>
                                <span v-else-if="key === 'disabled_at' && c[1] !== null">{{ $t('systems.logs.inactive') }}</span>
                                <span v-else>
                                    <template v-if="c[1] === ''"
                                        >-</template
                                    >
                                    <template v-else>{{ c[1] }}</template>
                                </span>
                            </div>
                        </td>
                        <td>
                            {{ log.user_name }}
                        </td>
                        <td>
                            <span v-if="log.device !== null"
                                ><b>{{ log.device.model }}</b
                                ><br
                            /></span>
                            <span v-if="log.device !== null">{{ log.device.name }}</span>
                            <span v-if="log.device !== null">{{ log.device.identifier }}</span>
                        </td>
                    </tr>
                </tbody>

                <tr v-if="items.length === 0">
                    <td class="no-padding" colspan="6">
                        <div class="alert alert--danger no-margin-bottom" role="alert">
                            {{ $t('users.no_changelog') }}
                        </div>
                    </td>
                </tr>

                <TablePagination v-if="paginationData" :paginationData="paginationData" :visibleAmount="items.length" @goToPrevPage="prevPageHandler" @goToNextPage="nextPageHandler" />
            </table>
        </div>
    </div>
</template>

<script>
import openWindow from '@/mixins/openWindow';
import systemsTable from '@/mixins/systemsTable';
import PageHeader from '@/components/PageHeader';
import TablePagination from '@/components/TablePagination';
import paginatedTable from '@/mixins/paginatedTable';
import formatDate from '@/mixins/formatDate';
import PageSubnavigation from '@/components/PageSubnavigation.vue';
import generalLinks from '@/mixins/generalLinks';

export default {
    components: { PageHeader, TablePagination, PageSubnavigation },
    mixins: [paginatedTable, openWindow, systemsTable, formatDate, generalLinks],
    data() {
        return {
            userId: false,
            apiType: 'users',
            fetchApi: 'getUserChangelog',
            responseField: 'logs',
            // searchFields: ['name', 'address', 'label', 'errorcode'],
            fields: [
                {
                    title: 'users.changelog_date',
                    sortable: false,
                    width: '15%',
                },
                {
                    title: 'users.change',
                    sortable: false,
                    width: '12%',
                },
                {
                    title: 'users.changelog_old_value',
                    sortable: false,
                    width: '18%',
                },
                {
                    title: 'users.changelog_new_value',
                    sortable: false,
                    width: '18%',
                },
                {
                    title: 'users.changelog_changed_by',
                    sortable: false,
                    width: '15%',
                },
                {
                    title: 'users.changelog_device',
                    sortable: false,
                    width: '22%',
                },
            ],
        };
    },
    computed: {
        additionalParams() {
            return { id: this.userId };
        },
        filteredLogs() {
            if (!this.items) return [];
            return [...this.items];
        },
    },
    watch: {
        $route: 'loadItems',
    },
    created() {
        if (!this.userId) this.userId = this.$route.params.id;
        this.loadItems();
    },
    beforeRouteUpdate(to, from, next) {
        this.userId = to.params.id;
        // eventBus.$emit('clearSearch')
        this.loadItems();
        next();
    },
};
</script>
